/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgCompassDeviceListItemResponse
 */
export interface OrgCompassDeviceListItemResponse {
    /**
     * 
     * @type {string}
     * @memberof OrgCompassDeviceListItemResponse
     */
    mac_address: string;
    /**
     * 
     * @type {string}
     * @memberof OrgCompassDeviceListItemResponse
     */
    serial_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrgCompassDeviceListItemResponse
     */
    firmware_revision?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrgCompassDeviceListItemResponse
     */
    hardware_version?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrgCompassDeviceListItemResponse
     */
    is_compass_core: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrgCompassDeviceListItemResponse
     */
    battery_percentage?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrgCompassDeviceListItemResponse
     */
    compass_alert_mute_status?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof OrgCompassDeviceListItemResponse
     */
    last_auth_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrgCompassDeviceListItemResponse
     */
    last_user_display_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrgCompassDeviceListItemResponse
     */
    last_user_phone_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrgCompassDeviceListItemResponse
     */
    last_seen_at: string;
}

/**
 * Check if a given object implements the OrgCompassDeviceListItemResponse interface.
 */
export function instanceOfOrgCompassDeviceListItemResponse(value: object): value is OrgCompassDeviceListItemResponse {
    if (!('mac_address' in value) || value['mac_address'] === undefined) return false;
    if (!('is_compass_core' in value) || value['is_compass_core'] === undefined) return false;
    if (!('last_seen_at' in value) || value['last_seen_at'] === undefined) return false;
    return true;
}

export function OrgCompassDeviceListItemResponseFromJSON(json: any): OrgCompassDeviceListItemResponse {
    return OrgCompassDeviceListItemResponseFromJSONTyped(json, false);
}

export function OrgCompassDeviceListItemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgCompassDeviceListItemResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'mac_address': json['mac_address'],
        'serial_number': json['serial_number'] == null ? undefined : json['serial_number'],
        'firmware_revision': json['firmware_revision'] == null ? undefined : json['firmware_revision'],
        'hardware_version': json['hardware_version'] == null ? undefined : json['hardware_version'],
        'is_compass_core': json['is_compass_core'],
        'battery_percentage': json['battery_percentage'] == null ? undefined : json['battery_percentage'],
        'compass_alert_mute_status': json['compass_alert_mute_status'] == null ? undefined : json['compass_alert_mute_status'],
        'last_auth_id': json['last_auth_id'] == null ? undefined : json['last_auth_id'],
        'last_user_display_name': json['last_user_display_name'] == null ? undefined : json['last_user_display_name'],
        'last_user_phone_number': json['last_user_phone_number'] == null ? undefined : json['last_user_phone_number'],
        'last_seen_at': json['last_seen_at'],
    };
}

export function OrgCompassDeviceListItemResponseToJSON(json: any): OrgCompassDeviceListItemResponse {
    return OrgCompassDeviceListItemResponseToJSONTyped(json, false);
}

export function OrgCompassDeviceListItemResponseToJSONTyped(value?: OrgCompassDeviceListItemResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mac_address': value['mac_address'],
        'serial_number': value['serial_number'],
        'firmware_revision': value['firmware_revision'],
        'hardware_version': value['hardware_version'],
        'is_compass_core': value['is_compass_core'],
        'battery_percentage': value['battery_percentage'],
        'compass_alert_mute_status': value['compass_alert_mute_status'],
        'last_auth_id': value['last_auth_id'],
        'last_user_display_name': value['last_user_display_name'],
        'last_user_phone_number': value['last_user_phone_number'],
        'last_seen_at': value['last_seen_at'],
    };
}

